import { DomainCategoryEnum } from '@models/search/domain-category.enum';
import { DomainEnum } from '@models/search/domain.enum';

export const DOMAIN_CATEGORY_RECORD: Record<DomainEnum, DomainCategoryEnum> = {
  [DomainEnum.Marketing]: DomainCategoryEnum.MarketComm,
  [DomainEnum.Communication]: DomainCategoryEnum.MarketComm,
  [DomainEnum.Evenementiel]: DomainCategoryEnum.MarketComm,
  [DomainEnum.JournalismeRp]: DomainCategoryEnum.MarketComm,
  [DomainEnum.CommunityManagement]: DomainCategoryEnum.MarketComm,

  [DomainEnum.Ventes]: DomainCategoryEnum.BusinessManagement,
  [DomainEnum.RelationClientSupport]: DomainCategoryEnum.BusinessManagement,
  [DomainEnum.Achats]: DomainCategoryEnum.BusinessManagement,
  [DomainEnum.Conseil]: DomainCategoryEnum.BusinessManagement,
  [DomainEnum.DirectionEntreprise]: DomainCategoryEnum.BusinessManagement,

  [DomainEnum.DesignUxUi]: DomainCategoryEnum.CreaDesign,
  [DomainEnum.GraphismeIllustration]: DomainCategoryEnum.CreaDesign,
  [DomainEnum.ProductionAudiovisuelle]: DomainCategoryEnum.CreaDesign,

  [DomainEnum.Administration]: DomainCategoryEnum.RhAdminJuridique,
  [DomainEnum.RhFormation]: DomainCategoryEnum.RhAdminJuridique,
  [DomainEnum.Fiscalite]: DomainCategoryEnum.RhAdminJuridique,
  [DomainEnum.Juridique]: DomainCategoryEnum.RhAdminJuridique,

  [DomainEnum.ComptabiliteControleDeGestion]: DomainCategoryEnum.GestionFinance,
  [DomainEnum.Audit]: DomainCategoryEnum.GestionFinance,

  [DomainEnum.Logistique]: DomainCategoryEnum.LogistiqueProduction,
  [DomainEnum.ProductionFabricationExploitation]: DomainCategoryEnum.LogistiqueProduction,
  [DomainEnum.TravauxChantiers]: DomainCategoryEnum.LogistiqueProduction,
  [DomainEnum.QualiteMaintenance]: DomainCategoryEnum.LogistiqueProduction,

  [DomainEnum.DeveloppementInformatique]: DomainCategoryEnum.Tech,
  [DomainEnum.GestionDeProjetProduit]: DomainCategoryEnum.Tech,
  [DomainEnum.InfraReseauxTelecoms]: DomainCategoryEnum.Tech,

  [DomainEnum.EtudesStatistiquesData]: DomainCategoryEnum.ScienceRdIngenierie,
  [DomainEnum.EnergieMateriauxMecanique]: DomainCategoryEnum.ScienceRdIngenierie,
  [DomainEnum.ArchitectureUrbanisme]: DomainCategoryEnum.ScienceRdIngenierie,
  [DomainEnum.ConceptionGenieCivilGenieIndustriel]: DomainCategoryEnum.ScienceRdIngenierie,
  [DomainEnum.ChimieBiologieAgronomie]: DomainCategoryEnum.ScienceRdIngenierie,
  [DomainEnum.Environnement]: DomainCategoryEnum.ScienceRdIngenierie,

  [DomainEnum.ActivitesSocialesEtCulturelles]: DomainCategoryEnum.SanteSocialCulture,
  [DomainEnum.ServicesALaPersonne]: DomainCategoryEnum.SanteSocialCulture,
  [DomainEnum.Sante]: DomainCategoryEnum.SanteSocialCulture,
  [DomainEnum.Enseignement]: DomainCategoryEnum.SanteSocialCulture,

  [DomainEnum.HotellerieRestauration]: DomainCategoryEnum.HotellerieRestauration,
};
